
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaSolicitacoes: [],
	listaPrevisoes: [],
	listaEventos: [],
	listaPrevisoesEventos: [],
	listaOcorrencias: [],
	listaFronteiras: [],
	listaNegociadores: [],
	listaRumos: [{ id: 'RN', valor: 'Rumo Norte' }, { id: 'RS', valor: 'Rumo Sul' }, { id: 'NAC', valor: 'Nacional' }],
	listaFarolAtraso: [{ id: 'NENHUM', valor: 'Informação Insuficiente' }, { id: 'ADIANTADO', valor: 'Adiantado' }, { id: 'ATRASADO', valor: 'Atrasado' }],
	listaDiasDescarga: [
		{ id: 0, valor: 'Hoje' }, { id: 1, valor: '1 dia' }, { id: 2, valor: '2 dias' }, { id: 3, valor: '3 dias' }, { id: 4, valor: '4 dias' }, { id: 5, valor: '5 dias' },
		{ id: 6, valor: '6 dias' }, { id: 7, valor: '7 dias' }, { id: 8, valor: '8 dias' }, { id: 9, valor: '9 dias' }, { id: 10, valor: '10 dias' }
	],
	listaOperacoes: [],
	aguardando: false,
	filtro: {
		tipo_periodo: 'DATA_PREVISAO_CARGA',
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
		dias_descarga: 0
	}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'LINEHAUL_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'LINEHAUL_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

		case 'LINEHAUL_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

        case 'LINEHAUL_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};
		
		case 'LINEHAUL_SOLICITACAO_LISTADO':
			return {
				...state,
				listaSolicitacoes: action.payload.data[0] ? action.payload.data[0].solicitacoes || [] : [],
				listaPrevisoes: action.payload.data[0] ? action.payload.data[0].previsoes || [] : [],
				listaEventos: action.payload.data[0] ? action.payload.data[0].eventos || [] : [],
				listaPrevisoesEventos: action.payload.data[0] ? action.payload.data[0].lista_evento_previsao || [] : []
			};	
	
		case 'LINEHAUL_OCORRENCIA_LISTADO':
			return {
				...state,
				listaOcorrencias: action.payload.data || []
			};

		case 'LINEHAUL_FRONTEIRA_LISTADO':
			return {
				...state,
				listaFronteiras: action.payload.data || []
			};

		case 'LINEHAUL_NEGOCIADOR_LISTADO':
			return {
				...state,
				listaNegociadores: action.payload.data || []
			};

		case 'LINEHAUL_OPERACAO_LISTADO':
			return {
				...state,
				listaOperacoes: (action.payload.data || []).filter(item => item.id != 575) //EXCECAO_GERAL
			};
		
        default:
            return state;
    }
}
